import DefaultExamActions from "src/components/NewComponents/menuActions/DefaultExamActions";
import { useFinishedExamActions } from "./FinishedExamActions";
import { useUnfinishedExamActions } from "./UnfinishedExamActions";
import { useFolderItemActions } from "./useFolderItemActions";

interface ExamRow {
	id: number | string;
	status: string;
	folderId?: string;
	folderItemId?: string;
	[key: string]: unknown;
}

function FinishedExamActions({ row }: { row: ExamRow }) {
	const { actions } = useFinishedExamActions({
		row: {
			...row,
			allResolved: row.progress === 100,
		},
		onWatch: undefined,
	});
	const folderActions = useFolderItemActions(
		row as Required<Pick<ExamRow, "id" | "folderId" | "folderItemId">>,
		"exam",
	);

	const allActions = row.folderId
		? [...actions.slice(0, -1), folderActions, ...actions.slice(-1)]
		: actions;

	return <DefaultExamActions defaultItems={allActions} />;
}

function UnfinishedExamActions({ row }: { row: ExamRow }) {
	const { actions } = useUnfinishedExamActions({ row, onWatch: undefined });
	const folderActions = useFolderItemActions(
		row as Required<Pick<ExamRow, "id" | "folderId" | "folderItemId">>,
		"exam",
	);

	const allActions = row.folderId
		? [...actions.slice(0, -1), folderActions, ...actions.slice(-1)]
		: actions;

	return <DefaultExamActions defaultItems={allActions} />;
}

export default function ExamActions({ row }: { row: ExamRow }) {
	const Component =
		row.status === "active" ? UnfinishedExamActions : FinishedExamActions;

	return <Component row={row} />;
}
